import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  connect() {
    this.index = 0
  }

  selectTab(e) {
    const index = parseInt(e.currentTarget.dataset.index)
    this.switchTo(index)
  }

  switchTo(index) {
    this.index = index

    this.tabTargets.forEach((tab, i) => {
      const selected = i === index
      tab.setAttribute('aria-selected', selected)
      tab.setAttribute('tabindex', selected ? '0' : '-1')
    })

    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.removeAttribute('hidden')
      } else {
        panel.setAttribute('hidden', '')
      }
    })
  }

  // Keyboard navigation for tabs
  keydown(e) {
    let newIndex = this.index

    switch (e.key) {
      case 'ArrowRight':
        newIndex = (this.index + 1) % this.tabTargets.length
        break
      case 'ArrowLeft':
        newIndex = (this.index - 1 + this.tabTargets.length) % this.tabTargets.length
        break
      case 'Home':
        newIndex = 0
        break
      case 'End':
        newIndex = this.tabTargets.length - 1
        break
      default:
        return
    }

    e.preventDefault()
    this.switchTo(newIndex)
    this.tabTargets[newIndex].focus()
  }
}
